/*
// Esempio di funzione da aggiungere ai tuoi servizi API
export const updateBookingTicket = async (bookingId: number, ticketNumber: string, isSent: boolean) => {
    const response = await fetch(`/api/bookings/${bookingId}/ticket`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ticketNumber, isSent }),
    });
    if (!response.ok) throw new Error("Errore durante il salvataggio del ticket");
    return await response.json();
};
*/
import { Call } from "../../../api/apiCall";
// Assumendo che ActivityBookingDetails sia definita e importata qui
import { BookingNote } from "../model/BookingNote"; 

export const getBookingNotesByExternalId = async (ExternalBookingId: string): Promise<BookingNote[]> => { // <-- CORREZIONE DEL TIPO DI RITORNO
    try {
        const payload = {
            ExternalBookingId: ExternalBookingId
        };

        const res = await Call("bookings/getBookingNotes", "post", payload); 

        if (res.ok) {
            // CORREZIONE: Restituisce i dati parsati, non l'oggetto Response
            return await res.json() as BookingNote[]; 
        } else {
            const errorData = await res.json();
            console.error("Errore API lato server:", errorData);
            throw new Error(errorData.message || `Errore server: ${res.status}`);
        }
    } catch (error) {
        console.error("Errore di rete o server non raggiungibile:", error);
        throw new Error(error instanceof Error ? error.message : "Impossibile connettersi al servizio di ricerca.");
    }
};

// Nota: Il tipo di ritorno corretto è ActivityBookingDetails[]
export const upsertBookingNote = async (ExternalBookingId: string, userid: string, message: string): Promise<boolean> => {
    try {
        const payload = {
            ExternalBookingId: ExternalBookingId,
            UserId: userid,
            message: message
        };

        const res = await Call("bookings/upsertBookingNote", "post", payload); 

        // 1. Leggiamo il corpo della risposta UNA sola volta
        const data = await res.json();

        if (res.ok) {
            // Se il backend restituisce { success: true } o direttamente 1/0
            // Verifichiamo la proprietà 'success' o il valore restituito
            return data.success === true || data === true || data === 1;
        } else {
            // Se res.ok è false, data conterrà i dettagli dell'errore inviati dal server
            console.error("Errore API lato server:", data);
            throw new Error(data.message || `Errore server: ${res.status}`);
        }
    } catch (error) {
        // Gestione degli errori di rete o crash del JSON parse
        console.error("Errore di comunicazione:", error);
        throw new Error(error instanceof Error ? error.message : "Errore di connessione al server.");
    }
};

